import React from "react";
import { ProjectSPModel } from "../../../models/ProjectSPModel";
import { Grid, Typography } from "@mui/material";

interface IAdditionalDetailsSection {
  data: ProjectSPModel;
}

export const AdditionalDetailsSection = (props: IAdditionalDetailsSection) => (
  <Grid container spacing={1}>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" sx={{ fontWeight: "bolder" }}>
        License Requirement (if international)
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {props.data && props.data.isLicenseRequired ? "Yes" : "No"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" sx={{ fontWeight: "bolder" }}>
        If required license not available
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.licenseProcurementNextSteps) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" sx={{ fontWeight: "bolder" }}>
        Expected Competitors
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.expectedCompetitors) || "NA"}
      </Typography>
    </Grid>
    <Grid item xs={6} sm={4}>
      <Typography variant="subtitle2" sx={{ fontWeight: "bolder" }}>
        Additional information
      </Typography>
      <Typography variant="subtitle2" style={{ fontWeight: "normal" }}>
        {(props.data && props.data.additionalInformation) || "NA"}
      </Typography>
    </Grid>
  </Grid>
);
